// src/data/menuData.js

export const menuItems = [
  {
    id: 1,
    category: "Nepali",
    name: "Chicken Momo",
    desc: "Delicious Nepalese dumplings filled with spiced chicken.",
    price: 13.99,
    img: "/menu/momo-real1.jpg"
  },
  {
    id: 2,
    category: "Curries",
    name: "Butter Chicken",
    desc: "Tender chicken in a creamy tomato sauce.",
    price: 16.99,
    img: "/menu/curry-real1.jpg"
  },
  {
    id: 3,
    category: "Biryani",
    name: "Veg Biryani",
    desc: "Fragrant rice slow-cooked with vegetables and spices.",
    price: 14.99,
    img: "/menu/biryani-real1.jpg"
  },
  {
    id: 4,
    category: "Appetizers",
    name: "Samosa",
    desc: "Crispy pastry stuffed with potatoes and peas.",
    price: 5.99,
    img: "/menu/appetizer-real1.jpg"
  },
  {
    id: 5,
    category: "Tandoori",
    name: "Tandoori Chicken",
    desc: "Char-grilled chicken marinated in yogurt and spices.",
    price: 17.99,
    img: "/menu/tandoori-real1.jpg"
  }
];
